<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <ShareParkingTree
        v-on:handleTreeClick="handleTreeClick"
        shareType="share"
        moduleName="parking"
      ></ShareParkingTree>
    </div>
    <div class="right content-right list">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline">
          <div class="form-group">
            <label for>车位号:</label>
            <!-- <el-cascader
              v-model="search.sharedId"
              :options="parks"
              filterable
              :show-all-levels="false"
            ></el-cascader> -->
            <el-select
              class="space-parking"
              placeholder="请选择车位号"
              clearable
              filterable
              v-model="search.sharedId"
              @clear="search.sharedId = undefined"
            >
              <el-option
                v-for="{ value, label } in sharedSpaces"
                :key="label"
                :value="value"
                :label="label"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="form-group">
          <label for>共享车位:</label>
          <el-select
            class="space-parking"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="{ parkingId, parkingName } in parks"
              :key="parkingId"
              :value="parkingId"
              :label="parkingName"
            ></el-option>
          </el-select>
        </div> -->
          <div class="form-group others">
            <!--                 :disabled="search.sharedId.length <= 0" -->
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <!--                      :disabled="
                  search.sharedId.length <= 0 || tableListData.length >= 3
                "          -->
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add"
                @click="openAccountDrawer"
              >
                配置分账账户
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add"
                @click="openRatioDrawer"
              >
                配置分账比例
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-if="search.parkingId"
          v-loading="tableLoading"
        >
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
            width="200"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="楼层"
            prop="parkingLayer"
            width="120"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位号"
            prop="parkingUniqueId"
            width="120"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="车位类型" prop="userId">
            <template v-slot="scope">
              {{ scope.row.parkingType == "1" ? "企业车位" : "个人车位" }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位主"
            prop="parkingOwner"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="联系人"
            prop="parkingOwner"
          >
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="联系电话"
            prop="parkingOwnerPhone"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="平台账户状态"
            prop="payeeType"
          >
            <template slot-scope="scope">
              {{ handlePayeeType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="物业账户状态"
            prop="platformUser"
            width="170"
          >
            <!-- <template slot-scope="scope">
              {{ convertToUserLabel(scope.row.platformUser) }}
            </template> -->
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="个人账户状态"
            prop="profitType"
          >
            <template slot-scope="scope">
              {{ handleProfitType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="分账比例设置状态"
            prop="typeValue"
          ></el-table-column>

          <el-table-column show-overflow-tooltip label="是否启用">
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status == 1 ? true : false"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="(e) => handleSwitchChange(e, scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip label="操作" width="350">
            <template slot-scope="scope">
              <button
                class="edit operate-button"
                type="button"
                @click="editAccount(scope.row)"
              >
                账户修改
              </button>
              <button
                class="edit operate-button"
                type="button"
                @click="editRatio(scope.row)"
              >
                比例修改
              </button>
              <button
                class="edit operate-button"
                type="button"
                @click="showDetail(scope.row)"
              >
                详情
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <el-empty description="选择左侧车场查看车位详细配置"></el-empty>
        </div>
      </template>
    </div>

    <!-- 添加/修改 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="添加/修改分账配置"
      :visible.sync="dialogFormVisible"
      width="700px"
      @close="closeFormDialog"
      class="dialog-form"
    >
      <div class="clearfix">
        <el-form
          @submit.native.prevent
          class="fl config"
          style="width: 100%"
          ref="form"
          label-position="right"
          :model="form"
          :label-width="formLabelWidth"
          id="form"
        >
          <!-- <el-form-item label="车位号" prop="name" label-width="80px"> -->
          <!-- <el-cascader
              v-model="form.sharedId"
              :options="parks"
              filterable
              :show-all-levels="false"
            ></el-cascader> -->
          <!-- <el-select
                    class="space-parking"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="{ parkingId, parkingName } in parks"
                      :key="parkingId"
                      :value="parkingId"
                      :label="parkingName"
                    ></el-option>
                  </el-select> -->
          <!-- </el-form-item> -->

          <!-- <el-col :span="10">
              <el-form-item label="共享车位" prop="name" label-width="80px">
                <el-col>
                  <el-select
                    class="space-parking"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="{ parkingId, parkingName } in parks"
                      :key="parkingId"
                      :value="parkingId"
                      :label="parkingName"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col> -->

          <h5>分账配置</h5>
          <el-divider></el-divider>
          <el-form-item label="停车场名称">
            <el-col :span="18">
              <span style="padding-top: 15px; display: block">{{
                currentParkingName
              }}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="共享车位" prop="sharedId">
            <el-col :span="18">
              <el-select v-model="form.sharedId">
                <el-option
                  v-for="{ value, label } in sharedSpaces"
                  :key="label"
                  :value="value"
                  :label="label"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="分账方类型" prop="payeeType">
            <el-col :span="18">
              <el-select
                v-model="form.payeeType"
                @change="handlePayeeTypeChange"
              >
                <el-option label="平台" value="1"></el-option>
                <el-option label="物业（停车场）" value="2"></el-option>
                <el-option label="个人" value="3"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            label="平台用户"
            prop="platformUser"
            v-if="form.payeeType == 2"
          >
            <el-col :span="18">
              <el-cascader
                style="width: 100%; margin-top: -10px"
                v-model="form.platformUser"
                :options="userOps"
                @change="handleUserOpsChange"
                placeholder="请选择对应的平台用户"
              ></el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item label="分账类型" prop="profitType">
            <el-col :span="18">
              <el-select v-model="form.profitType">
                <el-option label="比例分账" value="1"></el-option>
                <!-- <el-option label="固定金额分账" value="2"></el-option> -->
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="form.profitType == 1 ? '比例' : '金额'"
            prop="typeValue"
          >
            <div style="display: flex; align-items: center">
              <el-col :span="16">
                <el-input v-model="form.typeValue"></el-input>
              </el-col>
              <span>{{ form.profitType == 1 ? "%" : "(元)" }}</span>
            </div>
          </el-form-item>
          <el-form-item
            :label="form.profitType == 1 ? '超时分账比例' : '超时分账金额'"
            prop="overtimeProfit"
          >
            <div style="display: flex; align-items: center">
              <el-col :span="16">
                <el-input v-model="form.overtimeProfit"></el-input>
              </el-col>
              <span>{{ form.profitType == 1 ? "%" : "(元)" }}</span>
            </div>
          </el-form-item>

          <template v-if="form.payeeType != '1'">
            <h5>个人信息</h5>
            <el-divider></el-divider>
            <el-form-item
              label="手机号"
              prop="mobile"
              style="vertical-align: middle"
            >
              <el-col :span="16">
                <el-input v-model="form.mobile"></el-input>
              </el-col>
              <i
                style="
                  margin-left: 10px;
                  font-size: 20px;
                  color: #999;
                  cursor: pointer;
                "
                class="el-icon-search"
                @click="onUserInfoSearch"
              ></i>
            </el-form-item>
            <el-form-item label="小程序用户Id" prop="userId">
              <el-col :span="18">
                <el-input v-model="form.userId" readonly></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="小程序用户openId" prop="openId">
              <el-col :span="18">
                <el-input v-model="form.openId" readonly></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="收款方真实姓名" prop="payeeName">
              <el-col :span="18">
                <el-input v-model="form.payeeName"></el-input>
              </el-col>
            </el-form-item>
          </template>
          <!-- <h5>提现配置</h5>
          <el-divider></el-divider>
          <el-form-item label="提现类型" prop="address">
            <el-col :span="18">
              <el-select v-model="form.profitType">
                <el-option label="固定金额" value="1"></el-option>
                <el-option label="每月固定的某一天" value="2"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="form.profitType == 1 ? '金额' : '日期'"
            prop="address"
          >
            <div style="display: flex;align-items: center;">
              <el-col :span="16">
                <el-input v-model="form.address"></el-input>
              </el-col>
              <span>{{ form.profitType == 1 ? "(元)" : "日" }}</span>
            </div>
          </el-form-item> -->
          <h5>合同上传</h5>
          <el-divider></el-divider>
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-drawer
      title="配置分账账户"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="400px"
      @close="closeAccountDrawer"
    >
      <div style="padding: 0 20px; box-sizing: border-box">
        <el-form :model="accountForm" label-width="100px">
          <el-form-item label="银行卡卡号">
            <el-input
              v-model="accountForm.bankCardNo"
              placeholder="请输入银行卡卡号"
              :readonly="accountEditMode"
            ></el-input>
          </el-form-item>
          <el-form-item label="持卡机构">
            <el-input
              v-model="accountForm.bankName"
              placeholder="请输入持卡机构"
              :readonly="accountEditMode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="closeAccountDrawer"
              >确 定</el-button
            >
            <el-button @click="closeAccountDrawer">取 消</el-button>
          </el-form-item>
        </el-form>
        <!-- <div
          v-if="!accountEditMode"
          style="
            margin-top: 32px;
            padding: 16px;
            background: #f8f8f8;
            border-radius: 4px;
            color: #666;
            font-size: 14px;
          "
        >
          说明：此操作可设置账号下所有车位的分账账户，如需单独修改，请点击车场/列表后修改按钮。
        </div> -->
      </div>
    </el-drawer>

    <el-drawer
      title="配置分账比例"
      :visible.sync="ratioDrawerVisible"
      direction="rtl"
      size="400px"
      @close="closeRatioDrawer"
    >
      <div style="padding: 0 20px; box-sizing: border-box">
        <el-form :model="ratioForm" label-width="100px">
          <el-form-item label="车场名称">
            <el-input v-model="ratioForm.parkingName" readonly></el-input>
          </el-form-item>
          <h5 style="margin: 24px 0 8px 0">分账方：个人</h5>
          <el-form-item label="比例">
            <el-input
              v-model="ratioForm.personal.ratio"
              placeholder="请输入比例"
            ></el-input>
          </el-form-item>
          <el-form-item label="超时分账比例">
            <el-input
              v-model="ratioForm.personal.overtimeRatio"
              placeholder="请输入超时分账比例"
            ></el-input>
          </el-form-item>
          <h5 style="margin: 24px 0 8px 0">分账方：物业（车场）</h5>
          <el-form-item label="比例">
            <el-input
              v-model="ratioForm.property.ratio"
              placeholder="请输入比例"
            ></el-input>
          </el-form-item>
          <el-form-item label="超时分账比例">
            <el-input
              v-model="ratioForm.property.overtimeRatio"
              placeholder="请输入超时分账比例"
            ></el-input>
          </el-form-item>
          <h5 style="margin: 24px 0 8px 0">分账方：平台</h5>
          <el-form-item label="比例">
            <el-input
              v-model="ratioForm.platform.ratio"
              placeholder="请输入比例"
            ></el-input>
          </el-form-item>
          <el-form-item label="超时分账比例">
            <el-input
              v-model="ratioForm.platform.overtimeRatio"
              placeholder="请输入超时分账比例"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="closeRatioDrawer"
              >确 定</el-button
            >
            <el-button @click="closeRatioDrawer">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <el-drawer
      title="分账详情"
      :visible.sync="detailDrawerVisible"
      direction="rtl"
      size="500px"
      @close="
        () => {
          detailDrawerVisible = false;
        }
      "
    >
      <div style="padding: 0 20px; box-sizing: border-box">
        <el-descriptions
          title="车场信息"
          :column="1"
          border
          :label-style="{ width: '120px' }"
          :content-style="{ width: '240px' }"
        >
          <el-descriptions-item label="车场名称">{{
            detailData.parkingName
          }}</el-descriptions-item>
          <el-descriptions-item label="车位号">{{
            detailData.spaceNo
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          title="个人"
          :column="1"
          border
          style="margin-top: 24px"
          :label-style="{ width: '120px' }"
          :content-style="{ width: '240px' }"
        >
          <el-descriptions-item label="分账账户">{{
            detailData.personal.account
          }}</el-descriptions-item>
          <el-descriptions-item label="分账名称">{{
            detailData.personal.name
          }}</el-descriptions-item>
          <el-descriptions-item label="分账比例">{{
            detailData.personal.ratio
          }}</el-descriptions-item>
          <el-descriptions-item label="超时分账比例">{{
            detailData.personal.overtimeRatio
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          title="物业（车场）"
          :column="1"
          border
          style="margin-top: 24px"
          :label-style="{ width: '120px' }"
          :content-style="{ width: '240px' }"
        >
          <el-descriptions-item label="分账账户">{{
            detailData.property.account
          }}</el-descriptions-item>
          <el-descriptions-item label="分账名称">{{
            detailData.property.name
          }}</el-descriptions-item>
          <el-descriptions-item label="分账比例">{{
            detailData.property.ratio
          }}</el-descriptions-item>
          <el-descriptions-item label="超时分账比例">{{
            detailData.property.overtimeRatio
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          title="平台"
          :column="1"
          border
          style="margin-top: 24px"
          :label-style="{ width: '120px' }"
          :content-style="{ width: '240px' }"
        >
          <el-descriptions-item label="分账账户">{{
            detailData.platform.account
          }}</el-descriptions-item>
          <el-descriptions-item label="分账名称">{{
            detailData.platform.name
          }}</el-descriptions-item>
          <el-descriptions-item label="分账比例">{{
            detailData.platform.ratio
          }}</el-descriptions-item>
          <el-descriptions-item label="超时分账比例">{{
            detailData.platform.overtimeRatio
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 验证码弹窗 -->
    <el-dialog
      title="请输入验证码"
      :visible.sync="captchaDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="captcha-content">
        <div class="captcha-phone-info">
          <i class="el-icon-mobile-phone"></i>
          <span>验证码已发送至手机 <strong>{{ userPhone }}</strong></span>
        </div>
        <div class="captcha-input-group">
          <div class="captcha-input-wrapper">
            <div class="captcha-input-title">
              <i class="el-icon-lock"></i>
              <span>验证码</span>
            </div>
            <div class="captcha-input-container">
              <input
                v-for="(digit, index) in 6"
                :key="index"
                v-model="captchaDigits[index]"
                type="text"
                maxlength="1"
                class="captcha-digit-input"
                :class="{ 'active': captchaDigits[index] }"
                @input="handleDigitInput(index, $event)"
                @keydown="handleDigitKeydown(index, $event)"
                @focus="handleDigitFocus(index)"
                ref="captchaInputs"
              />
            </div>
            <div class="captcha-input-hint">
              <span>{{ captchaCode.length }}/6</span>
            </div>
          </div>
        </div>
        <div class="captcha-tip">
          <i class="el-icon-info"></i>
          <span>请输入6位数字验证码</span>
        </div>
        <div class="captcha-resend">
          <span class="resend-text">没收到验证码？</span>
          <el-button 
            type="text" 
            size="mini" 
            class="resend-btn"
            @click="resendCaptcha"
            :disabled="resendCountdown > 0"
          >
            {{ resendCountdown > 0 ? `${resendCountdown}s后重发` : '重新发送' }}
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCaptcha">取 消</el-button>
        <el-button type="primary" @click="confirmCaptcha" :loading="captchaLoading">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  shareParkCascade,
  shareUserInfo,
  updateShareProfitConfig,
  profitConfigList,
  updateConfigStatus,
  groupUserOps,
  shareSplitAccountConfigList,
} from "@/api/url";
import { PAYEE_TYPE, PROFIT_TYPE } from "./constant";
// import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
import ShareParkingTree from "@/page/commons/parking/commons/share-parking-tree.vue";
import * as utils from "@/utils/utils";
import Page from "@/page/commons/page";
import { mapState, mapMutations } from 'vuex';
export default {
  
  data() {
    return {
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      form: {
        // sharedId: [],
        sharedId: undefined,
        userId: "",
        openId: "",
        payeeName: "",
        payeeType: "",
        profitType: "1",
        typeValue: "",
        overtimeProfit: "",
        mobile: "",
        status: 1,
        platformUser: undefined,
      },
      configureForm: {
        groupId: "",
        code: [],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        sharedId: undefined,
        parkingId: undefined,
      },
      tableListData: [],
      tableListDataTitle: [],
      groupBaseConfigureData: [],
      groupConfigureData: [], //用户配置数据
      tableListDataExcel: {},
      formLabelWidth: "180px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      dialogConfigureVisible: false, //配置

      parks: [],
      sharedSpaces: [],
      shareUser: {},
      userOps: [],
      currentParkingName: undefined,
      utils,
      drawerVisible: false,
      accountForm: {
        bankCardNo: "",
        bankName: "",
      },
      ratioDrawerVisible: false,
      ratioForm: {
        parkingName: "",
        personal: { ratio: "", overtimeRatio: "" },
        property: { ratio: "", overtimeRatio: "" },
        platform: { ratio: "", overtimeRatio: "" },
      },
      accountEditMode: false,
      ratioEditMode: false,
      detailDrawerVisible: false,
      detailData: {
        parkingName: "测试车场A",
        spaceNo: "A-001",
        personal: {
          account: "6222 8888 8888 8888",
          name: "张三",
          ratio: "30%",
          overtimeRatio: "10%",
        },
        property: {
          account: "6222 9999 9999 9999",
          name: "物业公司",
          ratio: "50%",
          overtimeRatio: "20%",
        },
        platform: {
          account: "平台专用账户",
          name: "平台",
          ratio: "20%",
          overtimeRatio: "5%",
        },
      },
      // 验证码相关数据
      captchaDialogVisible: false,
      captchaCode: "",
      captchaLoading: false,
      pendingAction: null,
      pendingActionData: null,
      userPhone: "150****5634",
      resendCountdown: 0,
      captchaDigits: ["", "", "", "", "", ""],
    };
  },
  components: {
    Page,
    ShareParkingTree,
  },
  computed:{
			...mapState({
			curIndex: state => state.page.curIndex,
			rowsCount: state => state.page.rowsCount,
			}),
		},
  methods: {
    ...mapMutations(["getPage"]),
    tableList: function (curPage) {
      if (!this.search?.parkingId) return;
      this.$get(shareSplitAccountConfigList(), {
        parkingId: this.search.parkingId,
        page: curPage,
        limit: this.search.pageSize,
      }).then((data) => {
        if (data?.status === 200) {
          this.tableListData = (data?.data?.rows ?? []).map((item) => {
            return {
              ...item,
              parkingName: this.currentParkingName,
            };
          });
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          this.getPage(pageObj);
        }
      });
      this.tableLoading = false;
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    openDialog: function () {},
    closeFormDialog: function () {
      this.$refs["form"].resetFields();
    },
    searchList: function () {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });
      this.tableList();
    },
    clearSearch: function () {},
    addOrEdit: function (row) {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });
      this.dialogFormVisible = true;
      this.form = {
        // sharedId: [],
        sharedId: this.search.sharedId,
        userId: "",
        openId: "",
        payeeName: "",
        payeeType: "",
        profitType: "1",
        typeValue: "",
        overtimeProfit: "",
        mobile: "",
        status: 1,
      };
      if (Boolean(row?.id)) {
        this.form = {
          ...row,
          payeeType: row.payeeType + "",
          profitType: row.profitType + "",
        };
        this.getUserOps();
      }
    },
    addOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          if (!Boolean(_this.form?.id)) {
            _this
              .$postRequest(updateShareProfitConfig(), {
                ..._this.form,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功",
                  title: "成功",
                });
                _this.tableList();
                _this.dialogFormVisible = false;
              });
          } else {
            _this
              .$putRequest(updateShareProfitConfig(), {
                ..._this.form,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功",
                  title: "成功",
                });
                _this.tableList();
                _this.dialogFormVisible = false;
              });
          }
        }
      });
    },

    getShareParks() {
      this.$get(shareParkCascade()).then((res) => {
        if (res?.status == 200) {
          this.parks = res?.data ?? [];
          console.log("this.parks=>", this.parks);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getShareUserInfo(mobile) {
      this.$get(shareUserInfo(), { mobile }).then((res) => {
        this.form.userId = res?.data?.[0]?.value ?? "";
        this.form.openId = res?.data?.[0]?.openId ?? "";
      });
    },
    onUserInfoSearch() {
      this.getShareUserInfo(this.form.mobile);
    },
    handlePayeeType(row) {
      return PAYEE_TYPE[row.payeeType];
    },
    handleProfitType(row) {
      return PROFIT_TYPE[row.profitType];
    },
    handleSwitchChange(e, row) {
      this.pendingAction = 'handleSwitchChange';
      this.pendingActionData = { e, row };
      this.showCaptchaDialog();
    },
    handleRemove() {},
    handlePictureCardPreview() {},
    async handlePayeeTypeChange() {
      if (this.form.payeeType == 2) {
        await this.getUserOps();
      }
    },
    async getUserOps() {
      const data = await this.$get(groupUserOps());
      if (data.status == 200) this.userOps = data.data;
    },
    handleUserOpsChange(val) {
      if (!val) return;

      if (val.length != 2) this.form.platformUser = undefined;
      else {
        this.form.platformUser = val[1];
      }
    },
    convertToUserLabel: function (userId) {
      let targetLabel = "-";
      this.userOps.forEach((f) => {
        f.children.forEach((fc) => {
          if (fc.value == userId) {
            targetLabel = `${f.label}/${fc.label}`;
            return;
          }
        });
      });
      return targetLabel;
    },
    handleFilterSharedSpace() {
      this.sharedSpaces = [];
      if (this.parks && this.parks.length > 0) {
        const result = this.parks.filter(
          (f) => f.value === this.search.parkingId
        );
        if (result && result.length > 0) this.sharedSpaces = result[0].children;
      }
    },
    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        this.search.sharedId = undefined;
        this.currentParkingName = node.name;
        this.handleFilterSharedSpace();
        // 获取数据
        this.tableList(this.search.pageNumber);
      } else this.search.parkingId = undefined;
    },
    openAccountDrawer() {
      this.pendingAction = 'openAccountDrawer';
      this.pendingActionData = null;
      this.showCaptchaDialog();
    },
    closeAccountDrawer() {
      this.drawerVisible = false;
    },
    openRatioDrawer() {
      if (!this.search.parkingId) {
        this.$notify({ type: "warning", message: "请选择车场" });
        return;
      }
      this.pendingAction = 'openRatioDrawer';
      this.pendingActionData = null;
      this.showCaptchaDialog();
    },
    closeRatioDrawer() {
      this.ratioDrawerVisible = false;
    },
    editAccount(row) {
      this.pendingAction = 'editAccount';
      this.pendingActionData = row;
      this.showCaptchaDialog();
    },
    editRatio(row) {
      this.pendingAction = 'editRatio';
      this.pendingActionData = row;
      this.showCaptchaDialog();
    },
    showDetail(row) {
      this.pendingAction = 'showDetail';
      this.pendingActionData = row;
      this.showCaptchaDialog();
    },
    // 验证码相关方法
    showCaptchaDialog() {
      this.captchaCode = "";
      this.captchaDigits = ["", "", "", "", "", ""];
      this.captchaDialogVisible = true;
      
      // 自动发送验证码
      this.sendCaptcha();
      
      // 聚焦到第一个输入框
      this.$nextTick(() => {
        if (this.$refs.captchaInputs && this.$refs.captchaInputs[0]) {
          this.$refs.captchaInputs[0].focus();
        }
      });
    },
    cancelCaptcha() {
      this.captchaDialogVisible = false;
      this.captchaCode = "";
      this.captchaDigits = ["", "", "", "", "", ""];
      this.pendingAction = null;
      this.pendingActionData = null;
    },
    confirmCaptcha() {
      if (!this.captchaCode || this.captchaCode.length !== 6) {
        this.$message.error("请输入6位验证码");
        return;
      }
      
      this.captchaLoading = true;
      
      // 这里可以调用验证码验证接口
      // 模拟验证码验证
      setTimeout(() => {
        this.captchaLoading = false;
        
        // 验证码验证成功，执行相应的操作
        if (this.pendingAction === 'openAccountDrawer') {
          this.executeOpenAccountDrawer();
        } else if (this.pendingAction === 'openRatioDrawer') {
          this.executeOpenRatioDrawer();
        } else if (this.pendingAction === 'editAccount') {
          this.executeEditAccount(this.pendingActionData);
        } else if (this.pendingAction === 'editRatio') {
          this.executeEditRatio(this.pendingActionData);
        } else if (this.pendingAction === 'showDetail') {
          this.executeShowDetail(this.pendingActionData);
        } else if (this.pendingAction === 'handleSwitchChange') {
          this.executeHandleSwitchChange(this.pendingActionData);
        }
        
        // 关闭验证码弹窗
        this.captchaDialogVisible = false;
        this.captchaCode = "";
        this.pendingAction = null;
        this.pendingActionData = null;
      }, 1000);
    },
    executeOpenAccountDrawer() {
      this.accountEditMode = false;
      this.drawerVisible = true;
      this.accountForm = { bankCardNo: "", bankName: "" };
    },
    executeOpenRatioDrawer() {
      this.ratioEditMode = false;
      this.ratioForm = {
        parkingName: this.currentParkingName || "",
        personal: { ratio: "", overtimeRatio: "" },
        property: { ratio: "", overtimeRatio: "" },
        platform: { ratio: "", overtimeRatio: "" },
      };
      this.ratioDrawerVisible = true;
    },
    executeEditAccount(row) {
      this.accountEditMode = true;
      this.drawerVisible = true;
      this.accountForm = {
        bankCardNo: row.bankCardNo || "",
        bankName: row.bankName || "",
      };
    },
    executeEditRatio(row) {
      this.ratioEditMode = true;
      this.ratioDrawerVisible = true;
      this.ratioForm = {
        parkingName: row.parkingName || "",
        personal: {
          ratio: row.personalRatio || "",
          overtimeRatio: row.personalOvertimeRatio || "",
        },
        property: {
          ratio: row.propertyRatio || "",
          overtimeRatio: row.propertyOvertimeRatio || "",
        },
        platform: {
          ratio: row.platformRatio || "",
          overtimeRatio: row.platformOvertimeRatio || "",
        },
      };
    },
    executeShowDetail(row) {
      this.detailDrawerVisible = true;
      this.detailData = {
        parkingName: row.parkingName || "",
        spaceNo: row.uniqueId || "",
        personal: {
          account: row.personalAccount || "",
          name: row.personalName || "",
          ratio: row.personalRatio || "",
          overtimeRatio: row.personalOvertimeRatio || "",
        },
        property: {
          account: row.propertyAccount || "",
          name: row.propertyName || "",
          ratio: row.propertyRatio || "",
          overtimeRatio: row.propertyOvertimeRatio || "",
        },
        platform: {
          account: row.platformAccount || "",
          name: row.platformName || "",
          ratio: row.platformRatio || "",
          overtimeRatio: row.platformOvertimeRatio || "",
        },
      };
    },
    executeHandleSwitchChange(data) {
      const { e, row } = data;
      this.$postRequest(updateConfigStatus(), {
        id: row.id,
        status: e ? 1 : 2,
      }).then((res) => {
        if (res.status != 200) return this.$message.error(res.message);
        this.$message.success("设置成功");
        this.tableList();
      });
    },
    sendCaptcha() {
      // 这里可以调用发送验证码接口
      this.$message.success('验证码已发送至手机');
      
      // 开始倒计时
      this.resendCountdown = 60;
      const timer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    resendCaptcha() {
      if (this.resendCountdown > 0) return;
      
      // 这里可以调用重发验证码接口
      this.$message.success('验证码已重新发送');
      
      // 开始倒计时
      this.resendCountdown = 60;
      const timer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    handleDigitInput(index, event) {
      const value = event.target.value;
      
      // 只允许数字
      if (!/^\d$/.test(value)) {
        this.captchaDigits[index] = "";
        return;
      }
      
      this.captchaDigits[index] = value;
      
      // 自动跳转到下一个输入框
      if (value && index < 5) {
        this.$nextTick(() => {
          this.$refs.captchaInputs[index + 1].focus();
        });
      }
      
      // 更新验证码字符串
      this.updateCaptchaCode();
    },
    handleDigitKeydown(index, event) {
      // 处理退格键
      if (event.key === 'Backspace' && !this.captchaDigits[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.captchaInputs[index - 1].focus();
        });
      }
      
      // 处理回车键
      if (event.key === 'Enter') {
        this.confirmCaptcha();
      }
    },
    handleDigitFocus(index) {
      // 聚焦时选中内容
      this.$nextTick(() => {
        this.$refs.captchaInputs[index].select();
      });
    },
    updateCaptchaCode() {
      this.captchaCode = this.captchaDigits.join('');
    },
  },

  created: function () {},
  mounted: function () {
    this.tableListData = [
      {
        id: 1,
        parkingName: "A停车场",
        uniqueId: "A-001",
        payeeType: "1",
        userId: "-",
        openId: "-",
        mobile: "-",
        payeeName: "-",
        platformUser: "-",
        profitType: "1",
        typeValue: "60",
        status: 1,
      },
      {
        id: 2,
        parkingName: "B停车场",
        uniqueId: "B-002",
        payeeType: "2",
        userId: "user123",
        openId: "openid123",
        mobile: "13800000000",
        payeeName: "张三",
        platformUser: "物业用户",
        profitType: "1",
        typeValue: "40",
        status: 2,
      },
    ];
    this.getShareParks();
    this.getUserOps();
  },
  destroyed: function () {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
 height:calc(100vh - 200px);
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
  .delete,
  .chargingRules {
    display: inline-block;
    width: 40px;
    height: 20px;
    background: #278cd8;
    color: white;
    margin-right: 4px;
    font-size: 12px;
    line-height: 20px;
    border-radius: 4px;
  } */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
.configure-message {
  margin-right: 20px;
}
</style>
<style>
.config .el-form-item {
  margin: 0;
}
.config .dialog-form .el-divider {
  margin: 0;
  margin-bottom: 10px;
}
.config .dialog-form .el-select {
  width: 100%;
}
.config .el-popper.el-cascader__dropdown {
  z-index: 20000 !important;
}
.config .el-cascader {
  position: relative;
}
/* 增大弹出层内 el-input 输入框高度 */
.el-drawer__body .el-input__inner {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
}

/* 验证码弹窗样式 */
.captcha-content {
  text-align: center;
  padding: 20px 0;
}

.captcha-input-group {
  margin-bottom: 20px;
}

.captcha-input-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.captcha-input-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

.captcha-input-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 18px;
}

.captcha-input-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
}

.captcha-digit-input {
width: 50px!important;
  height: 50px!important;
  border: 2px solid #dcdfe6!important;
  border-radius: 8px!important;

  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  background: #fff;
  transition: all 0.3s ease;
  outline: none;
}

.captcha-digit-input:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.captcha-digit-input.active {
  border-color: #67c23a;
  background: #f0f9ff;
}

.captcha-digit-input:hover {
  border-color: #c0c4cc;
}

.captcha-input-hint {
  text-align: center;
  color: #909399;
  font-size: 14px;
  font-weight: 500;
}

.captcha-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.captcha-tip i {
  margin-right: 5px;
  color: #409EFF;
}

.captcha-phone-info {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #1890ff;
  font-size: 14px;
}

.captcha-phone-info i {
  margin-right: 8px;
  font-size: 16px;
  color: #1890ff;
}

.captcha-phone-info strong {
  color: #1890ff;
  font-weight: 600;
}

.captcha-resend {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.resend-text {
  color: #909399;
  font-size: 14px;
  margin-right: 8px;
}

.resend-btn {
  color: #409EFF;
  font-size: 14px;
  padding: 0;
}

.resend-btn:hover:not(:disabled) {
  color: #66b1ff;
}

.resend-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
